// extracted by css-extract-rspack-plugin
export default {"grammarField":"grammarField__r4D2M"};